import styled, { css } from 'styled-components';
import {
  TOOLBAR_DENSITY_TOKENS,
  TOOLBAR_ORIENTATION_HORIZONTAL,
  TOOLBAR_TONE_RAISED,
  TOOLBAR_VARIANT_FLOATING,
  type ToolbarDensity,
  type ToolbarOrientation,
  type ToolbarTone,
  type ToolbarVariant,
} from './Toolbar.constants';

interface RootProps {
  $orientation: ToolbarOrientation;
  $variant: ToolbarVariant;
  $density: ToolbarDensity;
  $tone: ToolbarTone;
}

export const Root = styled.div<RootProps>`
  display: inline-flex;
  align-items: center;
  ${({ $orientation, $density }) => {
    const tokens = TOOLBAR_DENSITY_TOKENS[$density];
    return $orientation === TOOLBAR_ORIENTATION_HORIZONTAL
      ? css`
          flex-direction: row;
          gap: ${tokens.gap};
        `
      : css`
          flex-direction: column;
          gap: ${tokens.gap};
        `;
  }}

  ${({ $variant, $density, $tone, theme: { colors = {}, elevation = {}, borderRadius = {} } }) =>
    $variant === TOOLBAR_VARIANT_FLOATING &&
    css`
      padding: ${TOOLBAR_DENSITY_TOKENS[$density].floatingPad};
      /* Floating chip reads on the same surface tone as the canvas it
         floats over — no border, the shadow does the lifting. The
         heavier ramp (level3) is intentional: without a border the
         chip needs more separation from the backdrop to read as a
         distinct affordance. Matches the V2 redesign's .ctb rule. */
      background: ${$tone === TOOLBAR_TONE_RAISED
        ? (colors.surfaceContainerHigh ?? '#292932')
        : (colors.surface ?? '#13131B')};
      border: 0;
      border-radius: ${borderRadius.full ?? '100px'};
      box-shadow: ${elevation.level3 ??
      '0 4px 8px 3px rgb(0 0 0 / 0.15), 0 1px 3px 0 rgb(0 0 0 / 0.30)'};
    `}
`;

export const Group = styled.div<{ $orientation: ToolbarOrientation; $density: ToolbarDensity }>`
  display: inline-flex;
  align-items: center;
  ${({ $orientation, $density }) => {
    const tokens = TOOLBAR_DENSITY_TOKENS[$density];
    return $orientation === TOOLBAR_ORIENTATION_HORIZONTAL
      ? css`
          flex-direction: row;
          gap: ${tokens.gap};
        `
      : css`
          flex-direction: column;
          gap: ${tokens.gap};
        `;
  }}
`;
